$(document).ready(function () {
    $('a[href="mailto:hello@modrefclothing.com"]').each(function () {
        // Check if the link already has target="_blank" and aria-label
        var target = $(this).attr('target');
        var ariaLabel = $(this).attr('aria-label');

        if (!target) {
            $(this).attr('target', '_blank');
        }

        if (!ariaLabel) {
            $(this).attr('aria-label', 'email hello@modrefclothing.com, this link will open in new window');
        }
    });
});
// Add aria-hidden="true" to all <br> tags
$(document).ready(function () {
    $('br').each(function () {
        $(this).attr('aria-hidden', 'true');
    });
});

// Select the anchor tag that links to the specified URL
$(document).ready(function () {
    $('a[href="https://modrefclothing.com"]').attr({
        'target': '_blank',
        'aria-label': 'Wholesale on modrefclothing, this link will open in a new tab'
    });
});


// main submenu
$(document).ready(function () {
    // Keydown listener on document
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            // Check if any dropdown button has aria-expanded true
            const $expandedButton = $('button[aria-expanded="true"]');

            if ($expandedButton.length > 0) {
                // Close the dropdown (Alpine will handle expanded variable)
                $expandedButton.attr('aria-expanded', 'false'); // Optional to keep in sync
                $expandedButton[0].dispatchEvent(new Event('click')); // Triggers Alpine toggle!

                // Set focus back to the button
                $expandedButton.focus();
            }
        }
    });
});


// Search button to foucs back wen click close button
$(document).ready(function () {
    // Store a reference to the search toggle button
    const $searchToggle = $('[x-ref="searchToggle"]');

    // Handle click on the close button inside the search form
    $('[x-ref="searchComponent"]').on('click', 'button[type="button"]', function () {
        // Delay focus to ensure Alpine's close() runs first
        setTimeout(function () {
            $searchToggle.trigger('focus');
        }, 10);
    });
});


// // filterdrawer js toggle attribute
// $(document).ready(function () {
//     // Wait 5 seconds before running the aria-expanded sync logic
//     setTimeout(function () {
//         $('data-island h3 > button').each(function () {
//             const $button = $(this);
//             const $collapse = $button.closest('data-island').find('[x-show="expanded"]');

//             function updateAriaExpanded() {
//                 const isHidden =
//                     $collapse.is('[hidden]') ||
//                     $collapse.css('display') === 'none' ||
//                     $collapse.css('height') === '0px';

//                 $button.attr('aria-expanded', !isHidden);
//             }

//             // Initial set after 5 seconds
//             updateAriaExpanded();

//             // Update aria-expanded on click, with polling
//             $button.on('click', function () {
//                 let tries = 0;
//                 function pollCollapseState() {
//                     updateAriaExpanded();
//                     tries++;
//                     if (tries < 10) {
//                         setTimeout(pollCollapseState, 50);
//                     }
//                 }
//                 pollCollapseState();
//             });
//         });
//     }, 5000); // 5 seconds delay
// });


$(document).ready(function () {
    const phoneHref = 'tel:+12137410621';
    const ariaLabelText = 'Phone number 213 741 0621, this link will open in new window';

    $(`a[href="${phoneHref}"]`).each(function () {
        $(this)
            .attr('aria-label', ariaLabelText)
            .attr('target', '_blank');
    });
});


$(document).ready(function () {
    $('a[href*="https://www.shopify.com?utm_campaign=poweredby"]').each(function () {
        $(this).attr('aria-label', 'Powered by Shopify, this link will open in a new tab');
        $(this).attr('target', '_blank');
        $(this).attr('rel', 'noopener noreferrer');
    });
});


$(document).ready(function () {
    const $button = $('button[aria-expanded]');
    const $icon = $button.find('div');

    $button.on('click', function () {
        setTimeout(function () {
            if ($icon.hasClass('rotate-0')) {
                $button.attr('aria-expanded', 'false');
            } else if ($icon.hasClass('rotate-180')) {
                $button.attr('aria-expanded', 'true');
            }
        }, 10);
    });
});


$(document).ready(function () {
    // Wait for AlpineJS to initialize completely
    setTimeout(function () {
        $('.break-word.flex.w-full.items-center.justify-between').each(function () {
            const $button = $(this);
            const $section = $button.closest('data-island');
            const $collapse = $section.find('[x-show="expanded"]');

            // Set initial ARIA attributes
            $button.attr({
                'role': 'button',
                'aria-expanded': 'true'
            });

            // Toggle aria-expanded on click
            $button.on('click', function () {
                const isExpanded = $button.attr('aria-expanded') === 'true';
                $button.attr('aria-expanded', String(!isExpanded));
            });

            // MutationObserver to watch for changes and restore aria-expanded if removed
            const observer = new MutationObserver(() => {
                // If aria-expanded is missing, recalculate and reapply
                if (!$button.is('[aria-expanded]')) {
                    const isHidden =
                        $collapse.is('[hidden]') ||
                        $collapse.css('display') === 'none' ||
                        $collapse.css('height') === '0px';
                    $button.attr('aria-expanded', String(!isHidden));
                }
            });

            observer.observe($section.get(0), {
                attributes: true,
                childList: true,
                subtree: true
            });
        });
    }, 5000); // Wait 5 seconds to allow Alpine to initialize
});


function enhanceAccessibility() {
    // 1. Add aria-hidden="true" to all <br> inside the target <ul>
    $('ul.relative.flex-auto.overflow-y-auto br').each(function () {
        if (!$(this).attr('aria-hidden')) {
            $(this).attr('aria-hidden', 'true');
        }
    });

    // 2. Add aria-label to phone links
    $('ul.relative.flex-auto.overflow-y-auto a[href^="tel"], ul.relative.flex-auto.overflow-y-auto a[href^="+"]').each(function () {
        const phone = $(this).text().trim();
        if (!$(this).attr('aria-label')) {
            $(this).attr('aria-label', `Call at ${phone}`);
        }
    });
}

// Run immediately and again with delay
enhanceAccessibility();
setTimeout(enhanceAccessibility, 100);

// Optional: continue checking for dynamic updates
setInterval(enhanceAccessibility, 1000);


// add img alt attribute
$(document).ready(function () {
    $("img").each(function () {
        var $this = $(this);
        if (typeof $this.attr("alt") === "undefined") {
            $this.attr("alt", "");
        }
    });
});

// delete empty heading and h1 to p 
// $(document).ready(function () {
//     $("data-island").each(function () {

//         $(this).find("h1, h2, h3, h4, h5, h6").each(function () {
//             var $heading = $(this);


//             if ($heading.text().trim() === "" && $heading.children().length === 0) {
//                 $heading.remove();
//             } else {

//                 var content = $heading.html();
//                 $heading.replaceWith("<p>" + content + "</p>");
//             }
//         });
//     });
// });

// - If product is sold out/unavailable: aria-label is removed
$(document).ready(function () {
    function toggleAriaLabel() {
        $(".add-to-cart-container button#addtocart").each(function () {

            if ($(this).is(":disabled")) {
                $(this).removeAttr("aria-label");
            }
        });
    }


    toggleAriaLabel();


    const target = document.body;
    const observer = new MutationObserver(function () {
        toggleAriaLabel();
    });

    observer.observe(target, { childList: true, subtree: true });
});


// if item color soldout 
function updateSoldOutState(el) {
    if ($(el).hasClass('sold-out')) {
        $(el)
            .attr('aria-disabled', 'true')
            .attr('tabindex', '-1')
            .attr('disabled', true);
    } else {
        $(el)
            .removeAttr('aria-disabled')
            .removeAttr('tabindex')
            .removeAttr('disabled');
    }
}

$('input').each(function () {
    updateSoldOutState(this);
});

const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
            updateSoldOutState(mutation.target);
        }
    });
});

$('input').each(function () {
    observer.observe(this, { attributes: true });
});

// Correct the label for better accessibility
$(document).ready(function () {
    const sizeMap = {
        "XS": "Extra Small",
        "S": "Small",
        "M": "Medium",
        "L": "Large",
        "XL": "Extra Large"
    };

    $('input[name="options[Size]"]').each(function () {
        const val = $(this).val().trim();
        if (sizeMap[val]) {
            $(this).attr("aria-label", sizeMap[val]);
            $('label[for="' + $(this).attr('id') + '"]').attr("aria-hidden", "true");
        }
    });
});

// Accessibility fixes for Size, names 
$(document).ready(function () {
    $('input[name="options[Color]"]').each(function () {
        const inputId = $(this).attr('id');
        const $label = $('label[for="' + inputId + '"]');
        const srText = $label.find('.sr-only').text().trim();

        if (srText) {
            $(this).attr('aria-label', srText);
            $label.attr('aria-hidden', 'true');
        }
    });
});


$(document).ready(function () {
  function cleanRoles() {
    $('.splide__slide[role="tabpanel"]').removeAttr('role');
    console.log('Removed role=tabpanel from slides');
  }

  setTimeout(cleanRoles, 1000); 
  setTimeout(cleanRoles, 3000); 


  const targetNode = document.querySelector('#splide01-list');
  if (targetNode) {
    const observer = new MutationObserver(function () {
      cleanRoles();
    });

    observer.observe(targetNode, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }
});

